import { render, staticRenderFns } from "./l20home.vue?vue&type=template&id=0309e39c&scoped=true&"
import script from "./l20home.vue?vue&type=script&lang=js&"
export * from "./l20home.vue?vue&type=script&lang=js&"
import style0 from "./l20home.vue?vue&type=style&index=0&lang=less&"
import style1 from "./l20home.vue?vue&type=style&index=1&id=0309e39c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0309e39c",
  null
  
)

export default component.exports